<template>
  <el-form-item label="会员卡号" prop="card_number" :error="error">
    <el-input
      v-model="valueBackUp"
      maxlength="16"
      show-word-limit
      clearable
      placeholder="请输入会员卡号"
      @change="handleChange"
      :disabled="isCardNumberSearching"
    />
  </el-form-item>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudentIdByCardNumber } from '@/api/student';

export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    excludeStudentId: {
      type: [String, Number],
      default: 0,
    },
  },
  data: () => ({
    valueBackUp: '',
    list: [],
    error: '',
    isCardNumberSearching: false,
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value;
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async handleChange(card_number) {
      if (this.isCardNumberSearching || !card_number) return;

      this.isCardNumberSearching = true;
      const { isError, data } = await getStudentIdByCardNumber({
        card_number,
        exclude_student_id: +this.excludeStudentId || 0,
      });
      this.isCardNumberSearching = false;
      if (isError) return;

      if (data.id) this.error = '该卡号已被使用，请输入其他卡号！';
    }
  },
  beforeMount() {
    this.valueBackUp = this.value;
  },
};
</script>
